import React from 'react'
import { Helmet } from 'react-helmet'
import NewsletterL1 from '../../../Componet/Newsletter/NewsletterL1'
import HerosectionHeader from '../../../Componet/Herosection/HerosectionHeader'
import PrivateCloud1 from '../../../Componet/Private_Cloud/PRIVATE_CLOUD1He'
import ConsultingForm from '../../../Componet/Consulting/ConsultingForm'

const MEETING_URL = 'https://meetings.hubspot.com/viacheslav-seifer'

function PrivateCloudHePage() {
    return (
        <div className="private-cloud-page-rtl" dir="rtl">
            <Helmet>
                <title>EpicFinal - פתרונות ענן פרטי</title>
                <meta
                    name="description"
                    content="פתרונות ענן פרטי לעסקים שצריכים יותר שליטה, בידוד, זמינות גבוהה וניהול אקטיבי של סביבת תשתית מותאמת."
                />
                <meta
                    name="keywords"
                    content="ענן פרטי, Private Cloud, managed private cloud, תשתית מבודדת, זמינות גבוהה, migration לענן, תשתית ייעודית"
                />
                <meta property="og:title" content="EpicFinal - פתרונות ענן פרטי" />
                <meta
                    property="og:description"
                    content="סביבות Private Cloud ייעודיות עם בידוד, זמינות גבוהה, גמישות תפעולית וניהול אקטיבי לעסקים עם דרישות תשתית מתקדמות יותר."
                />
                <meta property="og:type" content="website" />
                <meta property="og:url" content="https://epicfinal.com/he/private_cloud" />
                <meta property="og:locale" content="he_IL" />
                <meta property="og:site_name" content="EpicFinal" />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="EpicFinal - פתרונות ענן פרטי" />
                <meta
                    name="twitter:description"
                    content="ענן פרטי לעסקים שצריכים יותר שליטה, יציבות ואבטחה."
                />
            </Helmet>
            <HerosectionHeader folder1={"pages"} folder2={"Solutions"} name={"פתרונות ענן פרטי"} />
            <div className="page-content">
                <PrivateCloud1 />
                <ConsultingForm
                    language="he"
                    formId="epic-private-cloud-form"
                    requireHubspotCookie={true}
                    meetingUrl={MEETING_URL}
                    title="ספרו לנו איזו סביבת ענן אתם צריכים"
                    subtitle="השאירו פרטים קצרים ונחזור אליכם עם מענה מקצועי והכוונה ראשונית לתשתית הפרטית שלכם."
                />
                <NewsletterL1 />
            </div>
        </div>
    )
}

export default PrivateCloudHePage

